import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/footer";
import { ContactForm } from "@/components/form";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="container mx-auto flex-grow px-4 py-16">
        <div className="mx-auto max-w-7xl">
          <h1 className="mb-8 text-center text-3xl font-bold">Contact Us</h1>
          <p className="mx-auto mb-12 max-w-2xl text-center text-gray-600">
            Have questions about our janitorial business management platform? Our team is here to
            help. Fill out the form below and we'll get back to you as soon as possible.
          </p>

          <div className="mb-12 grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
              <div className="mb-4 flex items-center">
                <Phone className="mr-3 h-6 w-6 text-blue-600" />
                <h3 className="text-lg font-semibold">Phone</h3>
              </div>
              <p className="text-gray-600">(555) 123-4567</p>
              <p className="mt-1 text-gray-600">Mon-Fri: 9am - 5pm EST</p>
            </div>

            <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
              <div className="mb-4 flex items-center">
                <Mail className="mr-3 h-6 w-6 text-blue-600" />
                <h3 className="text-lg font-semibold">Email</h3>
              </div>
              <p className="text-gray-600">support@cleansweeppro.com</p>
              <p className="mt-1 text-gray-600">We respond within 24 hours</p>
            </div>

            <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
              <div className="mb-4 flex items-center">
                <MapPin className="mr-3 h-6 w-6 text-blue-600" />
                <h3 className="text-lg font-semibold">Office</h3>
              </div>
              <p className="text-gray-600">123 Business Ave, Suite 100</p>
              <p className="text-gray-600">San Francisco, CA 94107</p>
            </div>
          </div>

          <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
            <h2 className="mb-6 text-center text-2xl font-semibold">Send Us a Message</h2>
            <ContactForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
